import m from 'mithril';

/*
 * 站内跳转（带兜底）。
 *
 * 背景：底部班级导航 ClassFooterNav 和着陆页 ClassHubHero 都是用
 *   m.mount(独立根节点, 组件)
 * 挂到 body 下的，**不在 Flarum 的路由组件树里**。
 * 这种情况下 m.route.set(url) 有时不会驱动 Flarum 主视图更新，
 * 表现就是「点了链接没反应」（地址栏不变、页面不动），
 * 而此时我们又已经 preventDefault 掉了 <a> 的默认跳转，于是彻底无响应。
 *
 * 策略：
 *   1. 先按 SPA 方式走 m.route.set（无刷新，体验最好）
 *   2. 300ms 后检查地址栏有没有真的变化
 *      —— 没变说明 SPA 跳转没生效，改用原生跳转兜底（会整页刷新，但保证跳得过去）
 *
 * 为什么可以安全整页刷新：着陆页的「已看过」状态存在 sessionStorage
 * （见 utils/landingState.js），刷新后也不会重复弹出引导页。
 */
export default function navigateTo(url) {
  if (!url) return;

  const before = window.location.pathname + window.location.search;

  try {
    m.route.set(url);
  } catch (e) {
    // mithril 路由不可用（极端情况）→ 直接原生跳转
    window.location.href = url;
    return;
  }

  setTimeout(() => {
    const now = window.location.pathname + window.location.search;
    if (now === before) {
      window.location.href = url;
    }
  }, 300);
}
